// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CheckCompanyEmailAvailabilityQueryVariables = Types.Exact<{
  account: Types.Scalars['String']['input'];
  domain: Types.Scalars['String']['input'];
}>;

export type CheckCompanyEmailAvailabilityQuery = { __typename?: 'Query' } & {
  checkCompanyEmailAvailability: { __typename?: 'CompanyEmailAvailabilityResult' } & Pick<
    Types.CompanyEmailAvailabilityResult,
    'available' | 'unavailableReason' | 'clearingEmployeeIds'
  >;
};

export const CheckCompanyEmailAvailabilityDocument = /*#__PURE__*/ gql`
    query CheckCompanyEmailAvailability($account: String!, $domain: String!) {
  checkCompanyEmailAvailability(account: $account, domain: $domain) {
    available
    unavailableReason
    clearingEmployeeIds
  }
}
    `;

/**
 * __useCheckCompanyEmailAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckCompanyEmailAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCompanyEmailAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCompanyEmailAvailabilityQuery({
 *   variables: {
 *      account: // value for 'account'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCheckCompanyEmailAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckCompanyEmailAvailabilityQuery,
    CheckCompanyEmailAvailabilityQueryVariables
  > &
    ({ variables: CheckCompanyEmailAvailabilityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>(
    CheckCompanyEmailAvailabilityDocument,
    options,
  );
}
export function useCheckCompanyEmailAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckCompanyEmailAvailabilityQuery,
    CheckCompanyEmailAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>(
    CheckCompanyEmailAvailabilityDocument,
    options,
  );
}
// @ts-expect-error
export function useCheckCompanyEmailAvailabilitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckCompanyEmailAvailabilityQuery,
    CheckCompanyEmailAvailabilityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>;
export function useCheckCompanyEmailAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CheckCompanyEmailAvailabilityQuery | undefined,
  CheckCompanyEmailAvailabilityQueryVariables
>;
export function useCheckCompanyEmailAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckCompanyEmailAvailabilityQuery, CheckCompanyEmailAvailabilityQueryVariables>(
    CheckCompanyEmailAvailabilityDocument,
    options,
  );
}
export type CheckCompanyEmailAvailabilityQueryHookResult = ReturnType<typeof useCheckCompanyEmailAvailabilityQuery>;
export type CheckCompanyEmailAvailabilityLazyQueryHookResult = ReturnType<
  typeof useCheckCompanyEmailAvailabilityLazyQuery
>;
export type CheckCompanyEmailAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useCheckCompanyEmailAvailabilitySuspenseQuery
>;
